import fetch from "@/utils/fetch";

/* 获取核验进度 */

export function getPgress(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getMaterialExamineList',
    url: "eavar/publisher/progress",
    method: "post",
    data: params,
  });
}

// progress 是连续型电子出版物出版物的
export function getLxdzProgress(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getMaterialExamineList',
    url: "eavar/lxdz/publication/list",
    method: "post",
    data: params,
  });
}

// zym.文件上传后，修改p_file1、p_file2表记录
export function sUpdate0(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/updateCode101',
    url: "eavar/file/updateCode101",
    method: "post",
    data: params,
  });
}

// zym.省局审核：出版单位材料列表页面？
export function getPressList(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getMaterialList',
    //  url:'eavar/examine/details',
    url: "eavar/publisher/materials",
    method: "post",
    data: params,
  });
}

// 基本信息表保存
export function tabUpdate1(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/updateCode201',
    url: "eavar/material/update/201",
    method: "post",
    data: params,
  });
}

export function tabRead1(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getCode201',
    url: "eavar/material/code/201",
    method: "post",
    data: params,
  });
}

// 表 1-9：出版经营情况调查表 209
export function tabUpdate209(params) {
  return fetch({
    url: "eavar/material/update/209",
    method: "post",
    data: params,
  });
}

export function tabRead209(params) {
  return fetch({
    url: "eavar/material/code/209",
    method: "post",
    data: params,
  });
}

/* 表二 */

export function tabList2(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getCode202List',
    url: "eavar/material/code/202",
    method: "post",
    data: params,
  });
}

export function mebRemove(params) {
  return fetch({
    // url: 'Ydnj/Ydnj/deleteCode202',
    url: "eavar/material/delete/202",
    method: "post",
    data: params,
  });
}

export function mebClean(params) {
  return fetch({
    // url: 'Ydnj/Ydnj/clearCode202',
    url: "eavar/material/clear/202",
    method: "post",
    data: params,
  });
}

export function dicSeek(params) {
  return fetch({
    //  url:'System/System/getDataDictionaryDTOs',
    url: "/eavar/dictionary/code",
    method: "post",
    data: params,
  });
}

export function mebUpdate(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/updateCode202',
    url: "eavar/material/update/202",
    method: "post",
    data: params,
  });
}

export function tabRead2(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getCode202',
    url: "eavar/material/code/202",
    method: "post",
    data: params,
  });
}

/* 表三 */

export function tabUpdate3(params) {
  return fetch({
    // url: 'Ydnj/Ydnj/updateCode203',
    url: "eavar/material/update/203",
    method: "post",
    data: params,
  });
}

export function tabRead3(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getCode203',
    url: "eavar/material/code/203",
    method: "post",
    data: params,
  });
}

/* 表四 */

export function tabList4(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getCode204List',
    url: "eavar/material/code/204",
    method: "post",
    data: params,
  });
}

export function tab4Remove(params) {
  return fetch({
    // url: 'Ydnj/Ydnj/deleteCode204',
    url: "eavar/material/delete/204",
    method: "post",
    data: params,
  });
}

export function tab4Clean(params) {
  return fetch({
    // url: 'Ydnj/Ydnj/clearCode204',
    url: "eavar/material/clear/204",
    method: "post",
    data: params,
  });
}

export function tabUpdate4(params) {
  return fetch({
    // url: 'Ydnj/Ydnj/updateCode204',
    url: "eavar/material/update/204",
    method: "post",
    data: params,
  });
}

export function tabRead4(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getCode204',
    url: "eavar/material/code/204",
    method: "post",
    data: params,
  });
}

/* 表五 */

export function tabList5(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getCode205List',
    url: "eavar/material/code/205",
    method: "post",
    data: params,
  });
}

export function tab5Remove(params) {
  return fetch({
    // url: 'Ydnj/Ydnj/deleteCode205',
    url: "eavar/material/delete/205",
    method: "post",
    data: params,
  });
}

export function tab5Clean(params) {
  return fetch({
    // url: 'Ydnj/Ydnj/clearCode205',
    url: "eavar/material/clear/205",
    method: "post",
    data: params,
  });
}

export function tabUpdate5(params) {
  return fetch({
    // url: 'Ydnj/Ydnj/updateCode205',
    url: "eavar/material/update/205",
    method: "post",
    data: params,
  });
}

export function tabRead5(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getCode205',
    url: "eavar/material/code/205",
    method: "post",
    data: params,
  });
}

/* 表六 */

export function tabList6(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getCode206List',
    url: "eavar/material/code/206",
    method: "post",
    data: params,
  });
}

export function tab6Remove(params) {
  return fetch({
    // url: 'Ydnj/Ydnj/deleteCode206',
    url: "eavar/material/delete/206",
    method: "post",
    data: params,
  });
}

export function tab6Clean(params) {
  return fetch({
    // url: 'Ydnj/Ydnj/clearCode206',
    url: "eavar/material/clear/206",
    method: "post",
    data: params,
  });
}

export function tabUpdate6(params) {
  return fetch({
    // url: 'Ydnj/Ydnj/updateCode206',
    url: "eavar/material/update/206",
    method: "post",
    data: params,
  });
}

export function tabRead6(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getCode206',
    url: "eavar/material/code/206",
    method: "post",
    data: params,
  });
}

/* 表七 */

export function tabUpdate7(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/updateCode207',
    url: "eavar/material/update/207",
    method: "post",
    data: params,
  });
}

export function tabRead7(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getCode207',
    url: "eavar/material/code/207",
    method: "post",
    data: params,
  });
}

/* 表八 */

export function tabList8(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getCode208List',
    url: "eavar/material/code/208",
    method: "post",
    data: params,
  });
}

export function tab8Remove(params) {
  return fetch({
    // url: 'Ydnj/Ydnj/deleteCode208',
    url: "eavar/material/delete/208",
    method: "post",
    data: params,
  });
}

export function tab8Clean(params) {
  return fetch({
    // url: 'Ydnj/Ydnj/clearCode208',
    url: "eavar/material/clear/208",
    method: "post",
    data: params,
  });
}

// zym.人员基本情况登记表 - 新增、修改
export function tabUpdate8(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/updateCode208',
    url: "eavar/material/update/208",
    method: "post",
    data: params,
  });
}

export function tabRead8(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getCode208',
    url: "eavar/material/code/208",
    method: "post",
    data: params,
  });
}

/* 表九 */

export function tabList9(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getCode301List',
    url: "eavar/material/code/301",
    method: "post",
    data: params,
  });
}

export function tab9Remove(params) {
  return fetch({
    // url: 'Ydnj/Ydnj/deleteCode301',
    url: "eavar/material/delete/301",
    method: "post",
    data: params,
  });
}

export function tab9Clean(params) {
  return fetch({
    // url: 'Ydnj/Ydnj/clearCode301',
    url: "eavar/material/clear/301",
    method: "post",
    data: params,
  });
}

export function tabUpdate9(params) {
  return fetch({
    // url: 'Ydnj/Ydnj/updateCode301',
    url: "eavar/material/update/301",
    method: "post",
    data: params,
  });
}

export function tabRead9(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getCode301',
    url: "eavar/material/code/301",
    method: "post",
    data: params,
  });
}

export function subExcel(params) {
  return fetch({
    // url: 'Ydnj/Ydnj/importCode301',
    url: "eavar/material/import/301",
    method: "post",
    data: params,
  });
}

export function excelErrors(params) {
  return fetch({
    // url: 'Ydnj/Ydnj/exportLog',
    url: "export/export/exportLog",
    method: "post",
    data: params,
  });
}

// zym.音像、电子提交
export function subToPvc(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/submit',
    url: "eavar/publisher/submit",
    method: "post",
    data: params,
  });
}

// zym.音像、电子撤回
export function cancelTabSubmit(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/submit',
    url: "eavar/publisher/cancelSubmit",
    method: "post",
    data: params,
  });
}

/* 表 8导入 */

export function exPersons(params) {
  return fetch({
    // url: 'Ydnj/Ydnj/importCode208',
    url: "eavar/material/import/208",
    method: "post",
    data: params,
  });
}

/* 获取可拷贝的表 */

export function copyList(params) {
  return fetch({
    // url: 'Ydnj/Ydnj/getSynchroCodeList',
    url: "eavar/material/getSynchroCodeList",
    method: "post",
    data: params,
  });
}

/* 拷贝执行 */

export function copySet(params) {
  return fetch({
    // url: 'Ydnj/Ydnj/getBasicDTOByUscc',
    url: "eavar/material/getBasicDTOByUscc",
    method: "post",
    data: params,
  });
}

// zym.统计(提交之后，人员列表上调用了这个方法)
export function percentCount(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getWorkerProportion',
    url: "eavar/statistic/worker",
    method: "post",
    data: params,
  });
}

// zym.统计(提交之后，人员列表上调用了这个方法)
export function percentCountLxdz(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getWorkerProportion',
    url: "eavar/statistic/lxdzworker",
    method: "post",
    data: params,
  });
}

/*获取出版单位历史提交版本列表*/

export function pSubmitHistoryList(params) {
  return fetch({
    // url:'Ydnj/Ydnj/getPSubmitHistoryList',
    url: "eavar/publisher/history",
    method: "post",
    data: params,
  });
}

/*提交申报人信息*/
export function submitDeclare(params) {
  return fetch({
    // url:'Ydnj/Ydnj/savePOrganizationPersonnel',
    url: "eavar/material/updatePersonnel",
    method: "post",
    data: params,
  });
}

/*获取表1历史导入数据*/
export function code201HistoryData(params) {
  return fetch({
    // url:'Ydnj/Ydnj/getCode201HistoryData',
    url: "eavar/material/history/code/201",
    method: "post",
    data: params,
  });
}
/*获取表2历史导入数据*/

export function code202HistoryData(params) {
  return fetch({
    // url: 'Ydnj/Ydnj/getCode202HistoryData',
    url: "eavar/material/history/code/202",
    method: "post",
    data: params,
  });
}
/*获取表4历史导入数据*/

export function code204HistoryData(params) {
  return fetch({
    // url: 'Ydnj/Ydnj/getCode204HistoryData',
    url: "eavar/material/getCode204HistoryData",
    method: "post",
    data: params,
  });
}
/*上传图片*/

export function postImg(params) {
  return fetch({
    url: "/File/File/upload",
    method: "post",
    data: params,
  });
}

export function getPfileUrl(params) {
  return fetch({
    url: "/eavar/pfile/url",
    method: "post",
    data: params,
  });
}

//年度纪录下拉选择数据
export function getSelYearRecord(params) {
  return fetch({
    url: "/eavar/material/getSelYearRecord",
    method: "post",
    data: params,
  });
}

// 出版社获取年度的音电作品数据
export function tb9PullProductFromSystem(params) {
  return fetch({
    url: "/eavar/material/tb9PullProductFromSystem",
    method: "post",
    data: params,
  });
}



// WEBPACK FOOTER //
// ./src/api/pressRole/pressRole.js